import axios from 'axios'

export const httpClientPrivate = axios.create({
  validateStatus(status) {
    return status >= 200 && status < 400
  },
})

export default httpClientPrivate
